const apps = [
  {
    id: "1000",
    key: "1000",
    title: "销量全景综合分析",
    icon: null,
    path: "/sales-analysis:8123",
    type: 0,
    children: [
      {
        id: "2000",
        key: "2000",
        title: "概览",
        icon: null,
        path: "/sales-analysis",
        type: 1,
        children: [
          {
            id: "2004",
            key: "2004",
            title: "整体市场分析",
            icon: null,
            path: "/sales-analysis/market-overview",
            type: 1,
            children: []
          }
        ]
      },
      {
        id: "2002",
        key: "2002",
        title: "车型诊断",
        icon: null,
        path: "/sales-analysis",
        type: 1,
        children: [
          {
            id: "2013",
            key: "2013",
            title: "城市分析",
            icon: null,
            path: "/sales-analysis/submodel/city",
            type: 1,
            children: []
          },
          {
            id: "2012",
            key: "2012",
            title: "省份分析",
            icon: null,
            path: "/sales-analysis/submodel/province",
            type: 1,
            children: []
          },
          {
            id: "2011",
            key: "2011",
            title: "区域分析",
            icon: null,
            path: "/sales-analysis/submodel/area",
            type: 1,
            children: []
          },
          {
            id: "2010",
            key: "2010",
            title: "全国分析",
            icon: null,
            path: "/sales-analysis/submodel/contry",
            type: 1,
            children: []
          }
        ]
      },
      {
        id: "2001",
        key: "2001",
        title: "厂商品牌诊断",
        icon: null,
        path: "/sales-analysis",
        type: 1,
        children: [
          {
            id: "2009",
            key: "2009",
            title: "城市分析",
            icon: null,
            path: "/sales-analysis/manfbrand/city",
            type: 1,
            children: []
          },
          {
            id: "2008",
            key: "2008",
            title: "省份分析",
            icon: null,
            path: "/sales-analysis/manfbrand/province",
            type: 1,
            children: []
          },
          {
            id: "2007",
            key: "2007",
            title: "区域分析",
            icon: null,
            path: "/sales-analysis/manfbrand/area",
            type: 1,
            children: []
          },
          {
            id: "2006",
            key: "2006",
            title: "全国分析",
            icon: null,
            path: "/sales-analysis/manfbrand/contry",
            type: 1,
            children: []
          }
        ]
      },
      {
        id: "2003",
        key: "2003",
        title: "VIP报告",
        icon: null,
        path: "/sales-analysis",
        type: 1,
        children: [
          {
            id: "2014",
            key: "2014",
            title: "VIP报告",
            icon: null,
            path: "/reports-public/sales-overview?product=/sales-analysis",
            type: 1,
            children: []
          }
        ]
      }
    ]
  },
  {
    id: 1007,
    key: 1007,
    title: "新车上市",
    icon: "el-icon-monitor",
    path: "/newcar:8117",
    type: 0,
    children: [
      {
        id: "2059",
        key: "2059",
        title: "新车上市监测",
        icon: null,
        path: "/newcar",
        type: 1,
        children: [
          {
            id: "20594",
            key: "20594",
            title: "车型多维信息分析",
            icon: null,
            path: "/newcar/dimension",
            type: 1,
            children: []
          },
          {
            id: "20593",
            key: "20593",
            title: "新车上市预测",
            icon: null,
            path: "/newcar/prediction",
            type: 1,
            children: []
          },
          {
            id: "20592",
            key: "20592",
            title: "新车上市统计",
            icon: null,
            path: "/newcar/stat",
            type: 1,
            children: []
          },
          {
            id: "20591",
            key: "20591",
            title: "新车上市监测概览",
            icon: null,
            path: "/newcar/analy",
            type: 1,
            children: []
          }
        ]
      }
    ]
  },
  {
    id: "1013",
    key: "1013",
    title: "企业动态分析",
    icon: null,
    path: "/enterprise:8127",
    type: 0,
    children: [
      {
        id: "2065",
        key: "2065",
        title: "厂商品牌",
        icon: null,
        path: "#",
        type: 1,
        children: [
          {
            id: "20651",
            key: "20651",
            title: "厂商品牌概况",
            icon: null,
            path: "/enterprise/manfbrand-overview",
            type: 1,
            children: []
          }
        ]
      },
      {
        id: "2067",
        key: "2067",
        title: "基础查询",
        icon: null,
        path: "#",
        type: 1,
        children: [
          {
            id: "20672",
            key: "20672",
            title: "终端激励查询",
            icon: null,
            path: "/enterprise/terminal-excition-search",
            type: 1,
            children: []
          },
          {
            id: "20671",
            key: "20671",
            title: "终端奖励项查询",
            icon: null,
            path: "/enterprise/terminal-reward-search",
            type: 1,
            children: []
          }
        ]
      },
      {
        id: "2066",
        key: "2066",
        title: "车型分析",
        icon: null,
        path: "#",
        type: 1,
        children: [
          {
            id: "20662",
            key: "20662",
            title: "单车型终端支持分析",
            icon: null,
            path: "/enterprise/model-terminal-support-analysis",
            type: 1,
            children: []
          },
          {
            id: "20661",
            key: "20661",
            title: "车型概况",
            icon: null,
            path: "/enterprise/model-overview",
            type: 1,
            children: []
          }
        ]
      },
      {
        id: "2068",
        key: "2068",
        title: "VIP报告",
        icon: null,
        path: "#",
        type: 1,
        children: [
          {
            id: "20681",
            key: "20681",
            title: "VIP报告",
            icon: null,
            path: "/reports-public/Ter-support?product=/enterprise",
            type: 1,
            children: []
          }
        ]
      }
    ]
  }
];

const product = [
  {
    groupId: 1,
    groupName: "智库",
    descrip: null,
    url: null,
    children: [
      {
        groupId: 3,
        groupName: "综合看板",
        descrip:
          "通过指标可视化管理，及时掌握市场现状，从而快速定制并实施应对营销决策",
        url: null,
        children: [],
        productList: [
          {
            productId: 1000,
            productName: "销量全景",
            productGroupId: 3,
            status: 1,
            viewType: 2,
            url: "/sales-analysis:8123"
          },
          {
            productId: 1001,
            productName: "新能源综合",
            productGroupId: 3,
            status: 1,
            viewType: 2,
            url: "/newEnergy:8114"
          }
        ]
      },
      {
        groupId: 4,
        groupName: "营销",
        descrip: "车型/城市粒度的销量监测，更有深度分析与精准预测服务",
        url: null,
        children: [],
        productList: [
          {
            productId: 209818,
            productName: "销量分析",
            productGroupId: 19,
            status: 0,
            viewType: 2,
            url: "/sales-volume-analysis:8133"
          },
          {
            productId: 209797,
            productName: "销量组合",
            productGroupId: 19,
            status: 1,
            viewType: 1,
            url: "/sales-portfolio-query:8131"
          },
          {
            productId: 209809,
            productName: "销量比例",
            productGroupId: 19,
            status: 1,
            viewType: 2,
            url: "/sales-ratio-analysis:8132"
          }
        ]
      },
      {
        groupId: 5,
        groupName: "产品",
        descrip:
          "通过新车上市监测及车型配置库的搭建，助力企业车型全生命周期的价值提升",
        url: null,
        children: [],
        productList: [
          {
            productId: 1007,
            productName: "新车监测",
            productGroupId: 5,
            status: 1,
            viewType: 2,
            url: "/newcar:8117"
          },
          {
            productId: 1011,
            productName: "配置分析",
            productGroupId: 5,
            status: 1,
            viewType: 2,
            url: "/model-conf:8128"
          }
        ]
      },
      {
        groupId: 8,
        groupName: "渠道",
        descrip:
          "基于全网渠道数据，结合AI算法建立智能系统，迅速提高城市网点布局及管理效率",
        url: null,
        children: [],
        productList: [
          {
            productId: 1015,
            productName: "渠道监测及分析",
            productGroupId: 8,
            status: 1,
            viewType: 2,
            url: "/channel:8112"
          },
          {
            productId: 1016,
            productName: "汽车商圈分析",
            productGroupId: 8,
            status: 1,
            viewType: 2,
            url: "/channel/sq/index:8112"
          }
        ]
      },
      {
        groupId: 6,
        groupName: "行业",
        descrip:
          "行业内最快速、最真实的价格数据监测，累计覆盖56个全国省会城市及重点城市",
        url: null,
        children: [],
        productList: [
          {
            productId: 1012,
            productName: "价格监测及分析",
            productGroupId: 6,
            status: 1,
            viewType: 2,
            url: "https://i.way-s.cn/price/mainMenu?"
          },
          {
            productId: 1013,
            productName: "企业动态分析",
            productGroupId: 6,
            status: 1,
            viewType: 2,
            url: "/enterprise:8127"
          }
        ]
      },
      {
        groupId: 11,
        groupName: "互联网大数据",
        descrip:
          "快速挖掘互联网线上数据价值，并针对热点事件进行消费者评价方面的深度解读",
        url: null,
        children: [],
        productList: [
          {
            productId: 1020,
            productName: "互联网大数据",
            productGroupId: 11,
            status: 1,
            viewType: 2,
            url: "/big-data:8125"
          }
        ]
      },
      {
        groupId: 14,
        groupName: "新能源",
        descrip: "为新能源行业全价值链打造“一站式”服务通道",
        url: null,
        children: [],
        productList: []
      },
      {
        groupId: 7,
        groupName: "报告集市",
        descrip:
          "直观快捷展示竞品各类金融方案的对标结果， 为制定金融方案提供科学的依据",
        url: null,
        children: [],
        productList: [
          {
            productId: 1014,
            productName: "汽车金融业务分析",
            productGroupId: 7,
            status: 1,
            viewType: 2,
            url: "/finance:8118"
          }
        ]
      }
    ],
    productList: []
  },
  {
    groupId: 2,
    groupName: "智策",
    descrip: null,
    url: null,
    children: [
      {
        groupId: 15,
        groupName: "车型生命周期管理",
        descrip:
          "贯穿市场竞争分析、用户洞察、竞争力评估，竞争力优化，定价全流程应用场景",
        url: "/car-life-cycle",
        children: [
          {
            groupId: 23,
            groupName: "市场监测",
            descrip: null,
            url: null,
            children: [],
            productList: []
          },
          {
            groupId: 24,
            groupName: "竞争力分析",
            descrip: null,
            url: null,
            children: [],
            productList: []
          },
          {
            groupId: 25,
            groupName: "调整优化",
            descrip: null,
            url: null,
            children: [],
            productList: []
          }
        ],
        productList: []
      },
      {
        groupId: 16,
        groupName: "用户生命周期管理",
        descrip: "实现“潜客-粉丝-用户-忠诚用户-再购”的用户全生命周期价值管理",
        url: "/user-life-cycle",
        children: [
          {
            groupId: 26,
            groupName: "销售机会管理",
            descrip: null,
            url: null,
            children: [],
            productList: []
          },
          {
            groupId: 27,
            groupName: "用户忠诚度管理",
            descrip: null,
            url: null,
            children: [],
            productList: []
          },
          {
            groupId: 28,
            groupName: "客户关系管理",
            descrip: null,
            url: null,
            children: [],
            productList: []
          }
        ],
        productList: []
      },
      {
        groupId: 17,
        groupName: "运营管理智能决策",
        descrip: "“厂商总部-区域管理-经销商”的分层级运营管理优化平台",
        url: "/intelligent-decision",
        children: [
          {
            groupId: 29,
            groupName: "总部决策管理",
            descrip: null,
            url: null,
            children: [],
            productList: []
          },
          {
            groupId: 209726,
            groupName: "区域运营管理",
            descrip: null,
            url: null,
            children: [],
            productList: []
          },
          {
            groupId: 209727,
            groupName: "经销商运营管理",
            descrip: null,
            url: null,
            children: [],
            productList: []
          }
        ],
        productList: []
      },
      {
        groupId: 18,
        groupName: "后市场配件管理",
        descrip:
          "贯穿市场竞争分析、用户洞察、竞争力评估，竞争力优化，定价全流程应用场景",
        url: "/intelligent-decision",
        children: [
          {
            groupId: 29,
            groupName: "总部决策管理",
            descrip: null,
            url: null,
            children: [],
            productList: []
          },
          {
            groupId: 209726,
            groupName: "区域运营管理",
            descrip: null,
            url: null,
            children: [],
            productList: []
          },
          {
            groupId: 209727,
            groupName: "经销商运营管理",
            descrip: null,
            url: null,
            children: [],
            productList: []
          }
        ],
        productList: []
      },
      {
        groupId: 19,
        groupName: "消费者洞察",
        descrip: "消费者痛点与需求的全面挖掘与车型用户口碑洞察",
        url: "/intelligent-decision",
        children: [
          {
            groupId: 29,
            groupName: "总部决策管理",
            descrip: null,
            url: null,
            children: [],
            productList: []
          },
          {
            groupId: 209726,
            groupName: "区域运营管理",
            descrip: null,
            url: null,
            children: [],
            productList: []
          },
          {
            groupId: 209727,
            groupName: "经销商运营管理",
            descrip: null,
            url: null,
            children: [],
            productList: []
          }
        ],
        productList: []
      }
    ],
    productList: []
  }
];

export default [
  {
    url: "/v3/iw-framework/menu/get-all-menu不要了",
    type: "post",
    response: () => ({
      status: {
        status: 0,
        msg2Client: "OK",
        msg2Dev: " successfully！"
      },
      data: apps
    })
  }
  // {
  //   url: "/v3/iw-framework/index/get-auth-products",
  //   type: "post",
  //   response: () => ({
  //     status: {
  //       status: 0,
  //       msg2Client: "OK",
  //       msg2Dev: " successfully！"
  //     },
  //     data: product
  //   })
  // },
  // {
  //   url: "/v3/iw-framework/index/get-all-products",
  //   type: "post",
  //   response: () => ({
  //     status: {
  //       status: 0,
  //       msg2Client: "OK",
  //       msg2Dev: " successfully！"
  //     },
  //     data: product
  //   })
  // }
];
